import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Grid } from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';

import { IPrimitiveStore } from '../../../../../common/store/interface/IPrimitiveStore';
import { FilterTitle } from './FilterTitle';

interface ITagsFilterProperties {
  tags?: any;
  tagsCategories?: any;
  searchTagsIds: IPrimitiveStore<string[]>;
  setNewValue: (id: string, checked: boolean) => void;
  rootDomain?: any;
}

export const TagsFilter = observer(({ searchTagsIds }: ITagsFilterProperties) => {
  return (
    <Accordion TransitionProps={{ unmountOnExit: true }} style={{ boxShadow: 'none', position: 'inherit' }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content">
        <FilterTitle selectedCount={searchTagsIds.value.length} title={'Тэги'} />
      </AccordionSummary>
      <AccordionDetails>
        <Grid>
          <div>Теги не найдены</div>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
});
